import React from 'react';
import { useTranslation } from 'react-i18next';
import { css } from '@emotion/react';
import { CheckBox, ProColors } from '../../aura';
import { useFormContext } from '../../state';

export function Marketing(): JSX.Element {
  const { t } = useTranslation('input', { keyPrefix: 'marketing' });
  const {
    data: { acceptMarketing },
    setData,
  } = useFormContext();

  return (
    <CheckBox
      checked={acceptMarketing}
      onChange={value => {
        setData(current => ({ ...current, acceptMarketing: value }));
      }}
    >
      <span
        className="aura--copy-xs"
        css={css({
          color: ProColors.navy[800],
          fontWeight: 400,
          whiteSpace: 'pre-wrap',
        })}
      >
        {t('label')}
      </span>
    </CheckBox>
  );
}
